import React, { PropsWithChildren } from 'react';

import { Loader } from 'components/loader';

export const Suspense = ({ children }: PropsWithChildren) => (
  <React.Suspense fallback={<Loader isLoading />}>{children}</React.Suspense>
);
